"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authAuthContract = void 0;
const core_1 = require("@ts-rest/core");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authAuthContract = c.router({
    profile: {
        method: 'GET',
        path: '/profile',
        responses: {
            200: models_1.ZProfileResponseSchema,
            400: models_1.ZErrorResponseSchema,
            401: models_1.ZErrorResponseSchema,
            404: models_1.ZErrorResponseSchema,
        },
        summary: 'Returns a player object from the extracted JWT token',
    },
}, {
    pathPrefix: '/auth',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=auth.auth.contract.js.map